import PostalAddress from 'i18n-postal-address';
import upperFirst from 'lodash/upperFirst';

/**
 * @type {Address}
 */
const addressFields = [
  'honorific',
  'jobTitle',
  'firstName',
  'secondName',
  'lastName',
  'secondLastName',
  'companyName',
  'address1',
  'address2',
  'postalCode',
  'city',
  'country',
  'state',
  'province',
  'prefecture',
  'republic',
  'region',
  'do',
  'si',
  'dong',
  'gu',
  'addressNum',
];

/**
 *
 * @param {Address} address
 * @param {AddressKeys} key
 * @returns {string | undefined}
 */
const getAddressFieldValue = (address, key) => address[key] || undefined;

/**
 * @param {Address} address
 * @param {string | undefined} [countryCode='DE']
 * @returns {Array<AddressOutputLine>}
 */
const getFormattedAddress = (address, countryCode = 'DE') => {
  const myAddress = new PostalAddress();

  addressFields.map((fieldName) => {
    const fieldValue = getAddressFieldValue(address, fieldName);
    if (fieldValue !== undefined) {
      const functionName = `set${upperFirst(fieldName)}`;
      myAddress[functionName](fieldValue);
    }
  });
  myAddress.setFormat({ country: countryCode });
  return myAddress.output();
};

/**
 * Converts a payload object to an address output format.
 * This function extracts address-related fields from the payload and formats them
 * into an array of address output lines.
 *
 * @param {string | undefined} [streetAddress]
 * @param {string | undefined} [extendedAddress]
 * @param {string | undefined} [postalCode]
 * @param {string | undefined} [locality]
 * @param {string | undefined} [region]
 * @param {string | undefined} [countryName]
 * @param {string | undefined} [countryCode]
 * @returns {Array<AddressOutputLine>}
 */
export const getAddressFromPayload = ({
  streetAddress,
  extendedAddress,
  postalCode,
  locality,
  region,
  countryName,
  countryCode,
}) => {
  /**
   * @type {Address}
   */
  const addressData = {
    address1: streetAddress,
    address2: extendedAddress,
    city: locality,
    country: countryName,
    postalCode,
    region,
  };
  return getFormattedAddress(addressData, countryCode);
};

export default getFormattedAddress;
